<template>
    <div>
        <!-- <p>List page</p> -->
        <div class="record_info">
            <div class="task_back">
                <span style="font-size: 14px;font-weight: 600;padding-right: 20px;cursor: pointer;" @click="handleClick" v-matomo="{behaviorCategory: '自动化报告(任务生成记录)', event: '点击',  name: '列表(返回)'}">
                    <i class="el-icon-back"></i>返回</span>
            </div>
            <div class="task_id">任务：
                <el-tooltip class="item" effect="dark" :content="head.task_name" placement="top">
                    <span style="color: #000;">{{head.task_name}}</span>
                </el-tooltip>
            </div>
            <!--<div class="task_num">文件数量：<span style="color: #000;">{{ head.task_record_num.normal_num }}</span>/<span style="color: #000;">{{ head.task_record_num.total_num }}</span></div>-->
            <div class="task_states">生成状态：<span>成功（<i class="text-color-success"
                        style="font-style: normal;font-weight: 600;">{{ generate_status_info.success }}</i>）失败（<i class="text-color-error"
                        style="font-style: normal;font-weight: 600;">{{ generate_status_info.fail }}</i>）进行中（{{ generate_status_info.inProgress }}）未开启（{{ generate_status_info.unExecuted }}）</span></div>
            <div class="task_time">生成时间：<span style="color: #000;">{{head.generate_time}}</span></div>

        </div>
        <el-form :inline="true" :model="formInline" ref="formInline" class="demo-form-inline" size="mini">
            <el-form-item label="" prop="daily_file_name">
                <el-input v-model="formInline.daily_file_name" placeholder="请输入文件名称关键字搜索" style="width: 120px" clearable
                    @keyup.enter.native="onSubmit"></el-input>
            </el-form-item>
            <el-form-item label="" prop="account_id">
                <ESelect v-model="formInline.account_id" placeholder="账户筛选，支持名称、ID搜索" multiple collapse-tags filterable remote clearable
                    reserve-keyword :remote-method="(query) => remoteMethod(query, 'creator')" style="width: 220px">
                    <el-option v-for="item in filterAccountOptions" :key="item.id" :label="item.name + '(' + item.id + ')'"
                        :value="item.id">
                        <span style="float: left">{{ item.name }}（{{ item.id }}）</span>
                    </el-option>
                </ESelect>
            </el-form-item>
            <el-form-item label="" prop="subitem_ids">
                <ESelect v-model="formInline.subitem_ids" placeholder="产品筛选，支持名称、ID、包名搜索"
                style="width: 220px" multiple
                    collapse-tags clearable filterable remote :remote-method="(query) => remoteMethod(query, 'app')">
                    <el-option v-for="item in filterAppOptions" :key="item.subitem_id"
                                :label="item.subproject_name + '(' + item.subproject_id + ')' + '(' + item.subproject_content + ')'" :value="item.subitem_id">
                        <span style="float: left">{{ item.subproject_name }}（{{ item.subproject_id }}）{{item.subproject_content ? `（${item.subproject_content}）` : ''}}</span>
                    </el-option>
                </ESelect>
            </el-form-item>

            <el-form-item prop="plat_id">
                <SelectAll :options="isAllowedPlatList" v-model="formInline['plat_id']" :placeholder="'媒体'"/>
            </el-form-item>
                    
            <el-form-item label="" prop="template_id">
                <ESelect v-model="formInline.template_id" placeholder="模板筛选" style="width: 140px" class="tagswidth"
                 collapse-tags clearable filterable remote multiple>
                    <el-option :label="option.template_name" :value="option.template_id" v-for="option in filterTempOptions"
                        :key="option.template_id">
                    </el-option>
                </ESelect>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit" v-matomo="{behaviorCategory: '自动化报告(任务生成记录)', event: '点击',  name: '列表(任务详情-查询)'}">筛选</el-button>
                <el-button @click="resetForm('formInline')" v-matomo="{behaviorCategory: '自动化报告(任务生成记录)', event: '点击',  name: '列表(任务详情-重置筛选)'}">重置筛选</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tableData" style="width: 100%" stripe :header-cell-style="{ background: '#e8eaec', color: '#333' }"
            size="mini" class="create_vivo_list" :row-class-name="tableRowClassName" v-loading="loading"
            tooltip-effect="dark">
            <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="文件名称" min-width="140" prop="daily_file_name">
                <template slot-scope="scope">
                    <span>{{ scope.row.daily_file_name || '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="媒体" width="80" prop="task_record_num">
                <template slot-scope="scope">
                    <span>{{ scope.row.plat_name || '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="账户&产品" min-width="180">
                <!-- <template slot-scope="scope">
                    <p style="color: #409EFF;">
                    账户(<span>{{scope.row.account_num}}</span>)
                    产品(<span>{{scope.row.app_num.fail}}</span>)</p>
                </template> -->
                <template slot-scope="scope">
                        <el-popover width="460" trigger="hover">
                            <span slot="reference" class="text-color-primary pointer">
                                <span v-if="+scope.row.account_num>0">账户（{{scope.row.account_num}}）</span>
                                <span v-if="+scope.row.app_num>0"> 产品（{{scope.row.app_num}}）</span>
                                <span v-if="+scope.row.customer_num>0"> 客户（{{scope.row.customer_num}}）</span>
                            </span>
                            <div style="max-height: 360px;overflow-y: auto;">
                                <div class="company-list" v-if="scope.row.account_info.length>0">
                                    <h3>账户</h3>
                                    <p v-for="(item, index) in scope.row.account_info || []" :key="index" class="pl20 ellipsis" style="display: block;" :title="item.account_name+'-'+(scope.row.plat_name=='vivo'?item.user_name:item.account_id)">{{item.account_name}}（{{scope.row.plat_name=='vivo'?item.user_name:item.account_id}}）</p>
                                </div>
                                <div class="app-list" v-if="scope.row.app_info.length>0">
                                    <h3>产品</h3>
                                    <p v-for="(item, index) in scope.row.app_info || []" :key="index" class="pl20 ellipsis" style="display: block;" :title="item.subproject_name+'-'+item.subproject_id+'-'+item.subproject_content">
                                        {{item.subproject_name}}（{{item.subproject_id}}）{{item.subproject_content ? `（${item.subproject_content}）` : ''}}
                                    </p>
                                </div>
                                <div class="app-list" v-if="scope.row.customer_info.length>0">
                                    <h3>客户</h3>
                                    <p v-for="(item, index) in scope.row.customer_info || []" :key="index" class="pl20 ellipsis" style="display: block;" :title="item.company_name">{{item.company_name}}</p>
                                </div>
                            </div>
                        </el-popover>
                    </template>
            </el-table-column>
            <el-table-column label="模板" min-width="120" prop="template_name">
                <template slot-scope="scope">
                    <span>{{ scope.row.template_name || '--' }}</span>
                </template>
            </el-table-column>
            
            <el-table-column label="生成状态" min-width="90" show-overflow-tooltip prop="status">
                <template slot-scope="scope">
                        <span v-if="scope.row.generate_status=='0'" class="text-color-failed" :title="scope.row.status_text">未开启</span>
                        <span v-else-if="scope.row.generate_status=='1'" class="text-color-warn" :title="scope.row.status_text">数据抓取生成中</span>
                        <span v-else-if="scope.row.generate_status=='2'" class="text-color-warn" :title="scope.row.status_text">数据未出正在生成</span>
                        <span v-else-if="scope.row.generate_status=='3'" class="text-color-warn" :title="scope.row.status_text">正在生成</span>
                        <span v-else-if="scope.row.generate_status=='4'" class=" text-color-success" :title="scope.row.status_text">生成成功</span>
                        <span v-else-if="scope.row.generate_status=='5'" class="text-color-success" :title="scope.row.status_text">数据未出生成成功</span>
                        <template v-else-if="scope.row.generate_status=='6'">
                            <el-tooltip class="item" effect="dark" placement="top">
                                <span class="mr4 text-color-failed pointer">生成失败
                                    <i class="el-icon-warning-outline text-color-failed"></i>
                                </span>
                                <div slot="content" style="max-width: 500px;max-height: 300px;overflow-y: auto;" class="break-word">
                                    <div v-if="scope.row.generate_error" v-html="scope.row.generate_error"></div>
                                    <span v-else>生成失败</span>
                                </div>
                            </el-tooltip>
                        </template>
                        <span v-else-if="scope.row.generate_status=='7'" class="text-color-failed" :title="scope.row.status_text">排队中</span>
                        <span v-else>{{scope.row.generate_status}}</span>
                    </template>
            </el-table-column>
            <el-table-column label="生成时间" min-width="90" prop="generate_time">
                <template slot-scope="scope">
                    <span>{{ scope.row.generate_time || '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="生成耗时" min-width="100" prop="total_time">
                <template slot-scope="scope">
                    <span v-if="scope.row.total_time==='0'||scope.row.total_time===0">0秒</span>
                    <span v-else-if="!scope.row.total_time">--</span>
                    <span v-else>{{secondToDuration(scope.row.total_time)||'--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="80" fixed="right">
                <template slot-scope="scope">
                    <div v-if="pageFuncNames.includes('daily_task_button')">
                        <el-button size="mini" type="text" @click="handleDown(scope.$index, scope.row)" v-matomo="{behaviorCategory: '自动化报告(任务生成记录)', event: '点击',  name: '列表(任务详情-下载)'}">下载</el-button>
                    </div>
                    <span v-else>--</span>
                </template>
            </el-table-column>
        </el-table>

        <div style="text-align: center;padding-top: 20px;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="[10, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <ErrTipModal ref="errTipModal" />

    </div>
</template>

<script>
import {
    getTemplateSelecOptions,
    getRecordSearchTemplateOptions,
    getTemplateRecordInfoList,
    getTemplateRecordInfoListItems,
    getTemplateRecordInfoListDown
} from '@/api/efficiencyTool/record.js'
import SelectAll from '@/components/SelectAll';
import utils from '@/libs/utils.js';
import ErrTipModal from '../../modal/errorTipModal';
export default {
    name: "efficiencyTool_record_info",
    props: ['head', 'pageFuncNames', 'allowedPlatList'],
    components:{
        ErrTipModal,
        SelectAll
    },
    data() {
        return {
            filterTempOptions: [],
            filterAccountOptions: [],
            filterAppOptions: [],
            formInline: {
                daily_file_name: "",    //文件名称
                account_id: [], //账户
                template_id: [],     //模板
                subitem_ids: [],      //产品
                plat_id:[]
            },
            generate_status_info:{
                success: 0, 
                fail: 0, 
                inProgress: 0, 
                unExecuted: 0
            },
            params: [],  //创意详情
            loading: false,  // 表格loading
            expanditemloading: true,  //创意详情loading
            currentPage: 1,
            pageSize: 10,
            total: 10,
            monitor: null, //定时器
            equal: 1, //缓存请求赋值
            status_err: [],
            tableData: [],
            dialogVisible: false,
            expandrowkeys: []  //展开行
        }
    },
    mounted() {
        this.fetchgetList()
    },
    computed:{
        isAllowedPlatList() {
            return this.allowedPlatList;
        }
    },
    methods: {
        toConfigPage() {
            this.$emit("changePage", "config")
        },
        fetchgetList() {
            getRecordSearchTemplateOptions().then(res => {
                this.filterTempOptions = res.data
            },err => {
                this.$message.error(err.info);
            })
            this.onSubmit()
        },
        // remoteMethod(type) {
        //     GET_DETAIL_SEARCH_LIST({search_type:type}).then(res=>{
        //         let result = res.data
        //         let opt = `options_${type}`
        //         this[opt] = result
        //     })
        // },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.handleKill()
            this.init()
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            this.handleKill()
            this.init()
        },
        onSubmit() {
            this.handleKill()
            this.init()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$nextTick(() => {
                this.init()
            })
        },
        handleClick() {
            this.handleKill()
            this.delayedClear()
            this.$emit('goback')
        },
        // 下载
        handleDown(index, row) {
            getTemplateRecordInfoListDown({
                detail_record_id:row.task_detail_record_id,
                type:'1',
            }).then(res=>{
                if(res.code != 200) return
                let downloadFile = `/td/api/daily_task_detail_record/download?detail_record_id=${row.task_detail_record_id}&type=1`
                // this.downloadFile(`/daily_task_detail_record/download?detail_record_id=${row.task_detail_record_id}`,'下载')
                utils.exportFile(downloadFile);
                
            },err=>{
                let errData = err.data||{};
                let errList = errData.error_auth||[];
                if(errList.length>0){
                    this.$refs.errTipModal.showModal({
                        title:err.info||'以下账户无权限，无法下载',
                        subTitle:'',
                        actionType:'changeTaskDetailStatus',
                        isConfirm:false,
                        errList:errList,
                        actionData:'',
                    });
                }else{
                    this.$message.error(err.info||'操作失败');
                }
            })
        },
        downloadFile(url, filename) {
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.target = '_blank'; // 可选，如果想在新窗口中打开下载链接，请添加此行
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        remoteMethod(query, type) {
            if (query == '') {
                return
            }
            getTemplateSelecOptions({
                search_type: type,
                search: query,
                task_id:this.head.task_id,
                source:'record',      // task-任务页面,record-任务记录页面
            }).then(res => {
                let result = res.data
                if (type == 'creator') {
                    this.filterAccountOptions = result
                } else {
                    console.log('result', result)
                    this.filterAppOptions = result
                }
            },err => {
                this.$message.error(err.info);
            })
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex === 0) {
                return 'gray-row';
            }
            return '';
        },
        init() {
            this.handleKill()
            let obj = { ...this.formInline, pn: this.currentPage, rn: this.pageSize, task_record_id:this.head.task_record_id,task_id:this.head.task_id}
            this.loading = true
            this.polling(obj)
        },
        polling(params) {
            getTemplateRecordInfoList(params).then(res => {
                let result = res.data
                let tableList = result.list
                this.loading = false

                let createarr = []
                result.list.forEach(element => {
                    if (element.generate_status != 4 || element.generate_status != 5 || element.generate_status != 6) {
                        createarr.push(element.task_detail_record_id)
                    }
                });
                // clearTimeout(this.monitor)
                // this.monitor = null

                this.tableData = tableList
                this.currentPage = result.pageNum
                this.pageSize = result.pageSize
                this.total = result.totalCnt
                if (createarr.length != 0) {
                    let join_arr = createarr.join(',')
                    this.setTableLlisItems({task_detail_record_ids:join_arr})
                }
            },err => {
                this.$message.error(err.info);
            })
        },
        // 设置单独table更新
        setTableLlisItems(query) {
            getTemplateRecordInfoListItems(query).then(res=> {
                clearTimeout(this.monitor)
                this.monitor = null

                let addList = res.data
                if(addList.length != 0) {
                    this.generate_status_info = addList[0]['generate_status_info']
                }
                this.tableData.map(item=>{
                    addList.forEach(ele=> {
                        if(item.task_detail_record_id == ele.task_detail_record_id) {
                            item['total_time'] = ele['total_time']
                            item['generate_status'] = ele['generate_status']
                        }
                    })
                    return item
                })

                let createarr = []
                this.tableData.forEach(element => {
                    if (element.generate_status != 4 || element.generate_status != 5 || element.generate_status != 6) {
                        createarr.push(element.task_detail_record_id)
                    }
                });
                if (createarr.length != 0) {
                    let join_arr = createarr.join(',')
                    this.monitor = setTimeout(() => { this.setTableLlisItems({task_detail_record_ids:join_arr}) }, 10*1000)
                }
            },err => {
                clearTimeout(this.monitor)
                this.monitor = null
                // this.$message.error(err.info);
            })
        },
        handleKill() {
            for (let i = 1; i < 10; i++) {
                clearTimeout(this.monitor)
                this.monitor = null
                this.equal = 1
            }

        },
        delayedClear() {
            setTimeout(() => {
                for (let i = 1; i < 10; i++) {
                    clearTimeout(this.monitor)
                    this.monitor = null
                    this.equal = 1
                }
            }, 10*1000)
        },
        secondToDuration(val){
            return utils.secondToDuration(val);
        }
    },
    beforeDestroy() {
        this.handleKill()
        this.delayedClear()
    },
    destroyed() {
        this.handleKill()
        this.delayedClear()
    }
}
</script>

<style>
.create_vivo_list .el-table__expand-icon .el-icon-arrow-right {
    opacity: 0;
}
</style>
<style scoped>
.record_info {
    color: #606266;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    min-width: 600px;

    &>div {
        margin-right: 15px;
    }

}

.ellipsis {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.create_vivo_list tbody .cell div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.demo-form-inline {
    padding: 20px 20px 0;
    background: #f8f8f9;
    margin-bottom: 20px;
}
</style>
